/**
 * SessionManager Component
 * HIPAA Compliance: Manages session timeout and automatic logoff
 * Regulation: 45 CFR 164.312(a)(2)(iii) - Automatic Logoff
 */

import React, { useContext, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../context/AuthContext/AuthContext';
import { useSessionTimeout } from '../../../hooks/useSessionTimeout';
import SessionWarningModal from '../../Basic/SessionWarningModal';

const SessionManager = ({ children }) => {
  const { user, signOut } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleTimeout = useCallback(() => {
    signOut();
    navigate('/Login', {
      state: {
        message: 'Your session has expired due to inactivity. Please log in again.',
        type: 'warning'
      }
    });
  }, [signOut, navigate]);

  const handleWarning = useCallback(() => {
    // Could add audio notification or other alert here
  }, []);

  const {
    extendSession,
    remainingSeconds,
    isWarningVisible
  } = useSessionTimeout({
    onTimeout: handleTimeout,
    onWarning: handleWarning,
    enabled: !!user // Only enable when user is logged in
  });

  const handleLogoutNow = useCallback(() => {
    signOut();
    navigate('/Login');
  }, [signOut, navigate]);

  return (
    <>
      {children}
      <SessionWarningModal
        open={isWarningVisible && !!user}
        remainingSeconds={remainingSeconds}
        onExtendSession={extendSession}
        onLogout={handleLogoutNow}
      />
    </>
  );
};

export default SessionManager;
